import { BrowserAgent } from '@newrelic/browser-agent/dist/cjs/loaders/browser-agent';

// Same browser app as the former copy-paste snippet in public/index.html.
// These are public ingest keys; they ship in the client bundle.
if (process.env.NODE_ENV === 'production') {
  new BrowserAgent({
    info: {
      beacon: 'bam.nr-data.net',
      errorBeacon: 'bam.nr-data.net',
      licenseKey: '347f013883',
      applicationID: '124688497',
      sa: 1,
    },
  });
}
